import { isJapaneseHoliday } from "@chillnn-core/holiday-jp";
import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

import {
	RATE_MATRIX_HIGHLIGHT_ATTR,
	RATE_MATRIX_HIGHLIGHT_OVERLAY_CLASS,
} from "./highlight-class";
import { getWeekdayLabel, isSaturday, isSunday } from "../../../model/types";

type Props = {
	yearMonth: string;
	dates: string[];
	today: string;
	highlightedDate: string | null;
};

export const PlanRateMatrixDailyTableHeader = memo(
	({ yearMonth, dates, today, highlightedDate }: Props) => {
		const [year, month] = yearMonth.split("-");

		return (
			<TableHeader>
				{/* sticky は th 側。tr の sticky は表では効きにくい。z は行の isolate より上 */}
				<TableRow className="bg-white transition-none hover:bg-white">
					<TableHead className="sticky left-0 top-0 z-20 w-64 min-w-64 bg-white text-base tabular-nums text-zinc-950 hover:bg-white">
						{year}年{Number(month)}月
					</TableHead>
					{dates.map((date) => {
						const dayNum = Number(date.split("-")[2]);
						const weekday = getWeekdayLabel(date);
						const holiday = isJapaneseHoliday(new Date(date));
						const isColumnHighlighted = highlightedDate === date;

						return (
							<TableHead
								key={date}
								className={cn(
									"sticky top-0 z-10 w-20 min-w-20 bg-white hover:bg-white",
									date === today && "bg-zinc-200 hover:bg-zinc-200",
									isColumnHighlighted && RATE_MATRIX_HIGHLIGHT_OVERLAY_CLASS,
								)}
								{...(isColumnHighlighted ? { [RATE_MATRIX_HIGHLIGHT_ATTR]: "column" } : {})}
								justifyStyle="center"
							>
								<div className="flex flex-col items-center">
									<p className={cn("tabular-nums text-zinc-950", date === today && "font-semibold")}>
										{dayNum}
									</p>
									<p
										className={cn(
											"text-xs",
											isSaturday(date) && !holiday && "text-edited",
											(isSunday(date) || holiday) && "text-not-entered",
											!isSaturday(date) && !isSunday(date) && !holiday && "text-zinc-600",
										)}
									>
										{weekday}
									</p>
								</div>
							</TableHead>
						);
					})}
				</TableRow>
			</TableHeader>
		);
	},
);

PlanRateMatrixDailyTableHeader.displayName = "PlanRateMatrixDailyTableHeader";
